module.exports = __webpack_public_path__ + "static/media/ico_simulation_lip_upper.efd73a9d.png";